import {required} from "vuelidate/lib/validators";  
const website = {
    data() { 
      return {   
        websiteData: { 
          Siteadi: "", 
          Tip: "",  
          Url: "",
          Adminurl:null,
          Birimid: "3fa85f64-5717-4562-b3fc-2c963f66afa6", 
          Usturl: "", 
          Ustbirimid: "3fa85f64-5717-4562-b3fc-2c963f66afa6", 
          Ustfakulteid: "3fa85f64-5717-4562-b3fc-2c963f66afa6"
          }, 
  
          FormDataType:{
            Siteadi:{FieldName:"Siteadi",Field:"input",FieldTitle:this.$t('website.AddEdit.Siteadi')},  
            Tip:{FieldName:"Tip",Field:"combobox",FieldTitle:this.$t('website.AddEdit.Tip'),ComboDataArray:[]},  
            Url:{FieldName:"Url",Field:"input",FieldTitle:this.$t('website.AddEdit.Url')},   
            Adminurl:{FieldName:"Adminurl",Field:"input",FieldTitle:this.$t('website.AddEdit.Adminurl')},   
          } 
      }
    },  
    validations:{ 
      FormData: {  
        Siteadi: {required},   
        Tip: {required},  
        Url:{required},    
        Adminurl:{required},   
      }
 
  },
  created(){ 
    
    this.ActionsSabitGet(17).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.FormDataType.Tip.ComboDataArray.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].Value,
        });
      }
    });
  }
}
export default website